import React from "react";
import styled from "styled-components";

const ShortAbout = () => {
  return (
    <TheShortAbout>
      <div className="left-about">
        <h3>
          Get The Most Affordable Farm machineries You Need, At Your Doorstep
        </h3>
        <p>
          We make the purchase of agricultural equipment simple, efficient, and affordable for farmers and agricultural businesses. Our business model allows us to maintain highly competitive pricing by focusing on volume-based sales and sustaining strong relationships with trusted manufacturers and suppliers.
        </p>
      </div>
      <div className="line"></div>
      <div className="right-about">
        <h3>WELCOME TO</h3>
        <h2>AGROHARVEST MACHINERIES</h2>
        <p>
          Agro Harvest Machineries was established in 2001 in Hopkinsville
          Kentucky. We are a family owned and operated business that has been
          providing quality farm machinery to farmers in the region for over 20
          years. We pride ourselves on our commitment to customer satisfaction
          and our ability to provide a wide range of products at competitive
          prices. Our team of experienced professionals is dedicated to helping
          our customers find the right equipment for their needs, whether they
          are looking for new, used, or refurbished machinery. We are passionate
          about agriculture and are committed to supporting our local farming
          community.
        </p>
        <a href="/equipments">View Equipments</a>
      </div>
    </TheShortAbout>
  );
};

const TheShortAbout = styled.div`
  width: 100%;
  height: fit-content;
  padding: 4rem 2rem;
  background: var(--second-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;

  .left-about {
    flex: 1;
    h3 {
      font-size: 2.5rem;
      font-weight: 600;
      color: var(--primary-color);
      margin-bottom: 1rem;
    }
    p {
      font-size: 1.2rem;
      color: var(--third-color);
      font-weight: 500;
    }
  }

  .line {
    width: 2px;
    height: 300px;
    background: linear-gradient(
      to bottom,
      transparent,
      var(--primary-color),
      var(--third-color),
      transparent
    );
    margin: 0 1rem;
  }

  .right-about {
    flex: 1;
    h3 {
      font-size: 1.2rem;
      color: var(--third-color);
      letter-spacing: 2px;
      margin-bottom: 0.5rem;
    }
    h2 {
      font-size: 2rem;
      color: var(--primary-color);
      margin-bottom: 1.5rem;
      font-weight: 700;
    }
    p {
      font-size: 1rem;
      line-height: 1.6;
      color: #333;
      margin-bottom: 2rem;
    }
    a {
      display: inline-block;
      background: var(--third-color);
      color: var(--primary-color);
      padding: 0.8rem 2rem;
      border-radius: 0.5rem;
      text-decoration: none;
      font-weight: 600;
      transition: var(--transition);

      &:hover {
        background: var(--primary-color);
        color: var(--second-color);
      }
    }
  }

  @media screen and (max-width: 1366px) {
    gap: 2.5rem;
    .left-about h3 {
      font-size: 2.2rem;
    }
    .line {
      height: 280px;
    }
    .right-about h2 {
      font-size: 1.8rem;
    }
  }

  @media screen and (max-width: 1200px) {
    padding: 3rem 2rem;
    gap: 2rem;
    .left-about h3 {
      font-size: 2rem;
    }
    .line {
      height: 250px;
    }
    .right-about h2 {
      font-size: 1.6rem;
    }
  }

  @media screen and (max-width: 900px) {
    flex-direction: column;
    padding: 3rem 1.5rem;
    gap: 2rem;

    .left-about {
      text-align: center;
      h3 {
        font-size: 1.8rem;
      }
    }

    .line {
      width: 80%;
      height: 2px;
      background: linear-gradient(
        to right,
        transparent,
        var(--primary-color),
        var(--third-color),
        transparent
      );
      margin: 0;
    }

    .right-about {
      text-align: center;
      h2 {
        font-size: 1.5rem;
      }
      p {
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 600px) {
    padding: 2rem 1rem;
    gap: 1.5rem;

    .left-about {
      h3 {
        font-size: 1.4rem;
      }
      p {
        font-size: 1rem;
      }
    }

    .line {
      width: 90%;
    }

    .right-about {
      h3 {
        font-size: 1rem;
      }
      h2 {
        font-size: 1.2rem;
      }
      p {
        font-size: 0.9rem;
      }
      a {
        padding: 0.6rem 1.5rem;
        font-size: 0.9rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    padding: 1.5rem 0.8rem;

    .left-about {
      h3 {
        font-size: 1.2rem;
      }
      p {
        font-size: 0.9rem;
      }
    }

    .right-about {
      h2 {
        font-size: 1rem;
      }
      p {
        font-size: 0.85rem;
        line-height: 1.5;
      }
      a {
        padding: 0.5rem 1.2rem;
        font-size: 0.85rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    padding: 1rem 0.5rem;

    .left-about {
      h3 {
        font-size: 1rem;
      }
      p {
        font-size: 0.85rem;
      }
    }

    .right-about {
      h2 {
        font-size: 0.9rem;
      }
      p {
        font-size: 0.8rem;
      }
      a {
        padding: 0.4rem 1rem;
        font-size: 0.8rem;
      }
    }
  }
`;

export default ShortAbout;
